import { Client, cacheExchange, fetchExchange } from 'urql';
import { firebaseAuth } from '@/auth/firebase';

const API_URL = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '');

/**
 * Single urql client. Auth header reads (in order):
 *   1. live Firebase ID token (auto-refreshed via onIdTokenChanged)
 *   2. localStorage('access_token') as a fallback for non-Firebase modes
 *
 * Workspace header is always read from localStorage since users can switch
 * workspaces after sign-in.
 */
export const gqlClient = new Client({
  url: `${API_URL}/graphql`,
  // Default to cache-and-network so list queries revalidate on every mount:
  // show cached data instantly, then refetch in the background. Without this the
  // default cache-first serves stale data after navigation (e.g. a freshly saved
  // draft wouldn't appear on the Drafts page until a hard browser refresh).
  requestPolicy: 'cache-and-network',
  exchanges: [cacheExchange, fetchExchange],
  fetchOptions: () => {
    let token = localStorage.getItem('access_token') ?? '';
    const u = firebaseAuth?.currentUser as any;
    if (u?.accessToken) token = u.accessToken;
    const workspaceId = localStorage.getItem('workspace_id') ?? '';
    return {
      credentials: 'include',
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'X-Workspace-Id': workspaceId,
      },
    };
  },
});
